document.addEventListener('DOMContentLoaded', function() {
    const shareLinks = document.querySelectorAll('.share-link');

    if (shareLinks.length > 0) {
        shareLinks.forEach(function(shareLink) {
            shareLink.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                const tempInput = document.createElement('input');
                document.body.appendChild(tempInput);

                const currentUrl = window.location.href;
                tempInput.value = currentUrl;
                tempInput.select();
                document.execCommand('copy');
                document.body.removeChild(tempInput);

                const messageSpan = document.createElement('span');
                messageSpan.className = 'text';
                messageSpan.textContent = 'URL Copied';

                shareLink.appendChild(messageSpan);

                setTimeout(function() {
                    shareLink.removeChild(messageSpan);
                }, 2500);
            });
        });
    }
});
